// extracted by mini-css-extract-plugin
export default {"wrapper":"BrandLogo-module_wrapper_b2Rmw3","logo":"BrandLogo-module_logo_C5u_S1"};